import Resolution from 'engine/Resolution.js';
import {getTriggerTimes} from 'keyboard/TriggerTimeHelper.js';
import Tone from 'tone';
import {ROLL_EFFECT} from 'effects/live/constants.js';

class Rolling {
    constructor() {
        // set of track slice objects
        this.trackToSlices = {};
        this.trackToTransposes = {};
    }

    clear() {
        this.trackToSlices = {};
        this.trackToTransposes = {};
    }

    addTrackSlice(trackNumber, sliceNumber, transpose) {
        if (transpose === undefined) {
            if (trackNumber in this.trackToSlices) {
                this.trackToSlices[trackNumber].add(sliceNumber);
            } else {
                this.trackToSlices[trackNumber] = new Set([sliceNumber]);
            }
        } else {
            if (trackNumber in this.trackToTransposes) {
                this.trackToTransposes[trackNumber].add(transpose);
            } else {
                this.trackToTransposes[trackNumber] = new Set([transpose]);
            }
        }

    }

    deleteTrack(trackNumber) {
        if (trackNumber in this.trackToSlices) {
            delete this.trackToSlices[trackNumber]
        }

        if (trackNumber in this.trackToTransposes) {
            delete this.trackToTransposes[trackNumber]
        }
    }

    removeTrackSlice(trackNumber, sliceNumber, transpose) {
        if (transpose !== undefined) {
            let transposes = this.trackToTransposes[trackNumber];
            if (transposes === undefined) {
            } else if (transposes.size <= 1) {
                    delete this.trackToTransposes[trackNumber];
            } else {
                this.trackToTransposes[trackNumber].delete(transpose);
            }
        } else {
            let slices = this.trackToSlices[trackNumber];
            if (slices === undefined) {
            } else if (slices.size <= 1) {
                delete this.trackToSlices[trackNumber];
            } else {
                this.trackToSlices[trackNumber].delete(sliceNumber);
            }
        }
    }

    getTrackSlicesRolling(track) {
        let trackNumber = track.trackNumber;
        let trackSlices = [];
        let transposes = this.trackToTransposes[trackNumber] || [];
        transposes.forEach(
            transpose =>
                trackSlices.push(
                    new TrackSlice(parseInt(trackNumber), 0, transpose)));
        let slices = this.trackToSlices[trackNumber] || [];
        slices.forEach(
            slice =>
                trackSlices.push(
                    new TrackSlice(parseInt(trackNumber), slice, undefined)));
        return trackSlices;
    }

    getTriggerTimes(stepNumber, resolution) {
        return getTriggerTimes(stepNumber, resolution);
    }

    getTrackRollEffectIfAny(track) {
        for (let i in track.liveEffects.effects) {
            let effect = track.liveEffects.effects[i];
            if (effect.effect === ROLL_EFFECT) {
                return effect;
            }
        }

        return undefined;
    }

    // given step number out (of 1/32th steps i.e. the base resolution) and the resolution of the
    // rolling rate/time, returns a list of RollingTrigger objects
    getTriggers(stepNumber, resolution, track) {
        let rollEffect = this.getTrackRollEffectIfAny(track);
        if (rollEffect) {
            let rollFactor = rollEffect.rollFactor;
            resolution = resolution.getCopy();
            resolution.resolution *= rollFactor;
        }

        let triggerTimes = this.getTriggerTimes(stepNumber, resolution);
        let triggers = [];
        if (triggerTimes.length == 0) {
            return triggers;
        }

        this.getTrackSlicesRolling(track).forEach(
            trackSlice => 
                triggerTimes.forEach(
                    obj => triggers.push(new RollingTrigger(trackSlice, obj.time, obj.step))));

        return triggers;
    }
}

// Represents a track + slice combo that is rolling
class TrackSlice {
    constructor(trackNumber, sliceNumber, transpose) {
        this.trackNumber = trackNumber;
        this.sliceNumber = sliceNumber;
        this.transpose = transpose;
    }
}

// Represents a TrackSlice and a time for when to trigger this
// for the current step
class RollingTrigger {
    constructor(trackSlice, time, step) {
        this.trackSlice = trackSlice;
        this.time = time;
        this.step = step;
    }
}

export default Rolling;
